<template>
  <div id="upLoadFile">
    <div class="title">作品上传</div>
    <div class="form">
      <el-form
        label-position="right"
        label-width="70px"
        :model="formData"
        :rules="rules"
        ref="uploadForm"
      >
        <el-form-item label="作品名称" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="仅限中英文，10个字以内"
            class="input-item"
          ></el-input>
        </el-form-item>
        <el-form-item label="参赛单元" prop="competitionUnit">
          <el-select
            v-model="formData.competitionUnit"
            placeholder="请选择"
            class="works-type"
          >
            <el-option
              v-for="item in unitList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span class="tip" v-show="formData.competitionUnit == 2"
            >仅限全日制高校在校生及应届毕业生参加</span
          >
        </el-form-item>

        <el-form-item label="作品类别" prop="category">
          <el-select
            v-model="formData.category"
            placeholder="请选择"
            class="works-type"
            @change="cateChange"
          >
            <el-option
              v-for="item in categoryList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传封面" prop="cover">
          <el-button
            type="primary"
            class="button-inline"
            @click="fileUpload('coverFile')"
            >点击上传</el-button
          >
          <div class="upload-tip">
            支持jpg/png/gif格式，大小不超过5M，建议尺寸382x246
          </div>
          <div class="myuploadPreview" v-show="formData.coverFile.length != 0">
            <el-upload
              ref="coverFile"
              class="avatar-uploader myfile1"
              accept="image/gif,image/jpeg,image/x-png"
              :show-file-list="false"
              :on-change="
                (file, fileList) => {
                  elUpload(file, fileList, 'coverFile');
                }
              "
              :auto-upload="false"
            >
              <img v-if="coverUrl" :src="coverUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="上传作品" prop="contents">
          <el-button
            type="primary"
            class="button-inline"
            @click="fileUpload('contentFiles')"
            >点击上传</el-button
          >
          <span
            style="margin-left: 10px; color: red"
            v-if="formData.category == 2"
            v-show="showLoading"
            >上传中...</span
          >
          <div class="upload-tip" v-if="formData.category == 1">
            支持jpg/png/gif格式，5张以内，单张大小不超过10M
          </div>
          <div class="upload-tip" v-if="formData.category == 2">
            支持MP4格式，1920*1080像素
          </div>
          <template v-if="formData.category == 1">
            <div v-show="formData.contents.length != 0">
              <el-upload
                class="myfile2"
                list-type="picture-card"
                :before-upload="beforeAvatarUpload"
                :file-list="
                  formData.contents.filter((i) => i.status === 'success')
                "
                accept="image/gif,image/jpeg,image/x-png"
                :limit="5"
                action
                :http-request="handleUploadFn"
              >
                <template #default>
                  <i class="el-icon-plus"></i>
                </template>
                <template #file="{ file }">
                  <div>
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                      alt=""
                    />
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
              <el-dialog v-model="contentDialog">
                <img style="width: 100%" :src="contentUrl" alt="" />
              </el-dialog>
            </div>
          </template>
          <template v-else>
            <div v-show="formData.contents.length != 0">
              <el-upload
                class="myfile2"
                style="line-height: 0px"
                accept="video/mp4"
                action
                :http-request="handleVideoFn"
                :before-upload="ElfileUpload"
                :file-list="
                  formData.contents.filter((i) => i.status === 'success')
                "
              />
            </div>
          </template>
        </el-form-item>
        <el-form-item label="作品介绍" prop="description">
          <el-input
            type="textarea"
            v-model="formData.description"
            maxlength="200"
            show-word-limit
            class="input-item"
            resize="none"
            placeholder="200个字以内"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="推荐单位(选填)"
          prop="recommenderId"
          class="recommend-wrap"
          v-if="list"
        >
          <el-select
            v-model="formData.recommenderId"
            placeholder="请选择"
            class="works-type"
            style="width: 180px; margin-right: 10px"
          >
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- <el-cascader
            placeholder="请选择推荐单位"
            v-model="formData.recommend"
            :options="recommendList"
            :props="{ expandTrigger: 'hover' }"
            style="width: 180px; margin-right: 10px"
          ></el-cascader> -->
          <el-tooltip class="item" effect="dark" placement="top">
            <template #content>
              <div class="mytip">
                <div>您可根据信息来源填</div>
                <div>写推荐单位，如获奖</div>
                <div>将获得推荐单位加码</div>
                <div>奖。如没有可不填写。</div>
                <!-- <div>方合作推荐单位如下：</div>
                <div>映速</div>
                <div>明基旗舰店</div> -->
              </div>
            </template>
            <i class="el-icon-question tipIcon"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item
          label="学校名称"
          prop="school"
          v-if="formData.competitionUnit == 2"
        >
          <el-input
            v-model="formData.school"
            placeholder="仅限中英文，10个字以内"
            class="input-item"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="指导老师"
          prop="adviser"
          v-if="formData.competitionUnit == 2"
        >
          <el-input
            v-model="formData.adviser"
            placeholder="仅限中英文，10个字以内"
            class="input-item"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="学生证明"
          prop="studentCard"
          v-show="formData.competitionUnit == 2"
        >
          <el-button
            type="primary"
            class="button-inline"
            @click="fileUpload('studentFile')"
            >点击上传</el-button
          >
          <div class="checkInstance">
            <!-- <el-tooltip class="item" effect="dark" placement="top">
              <template #content>
                <div class="mytip">
                  <div>您可根据信息来源填写推荐</div>
                  <div>单位，如没有可不填写。官</div>
                  <div>方合作推荐单位如下：</div>
                  <div>映速</div>
                  <div>明基旗舰店</div>
                </div>
              </template>
              <i class="el-icon-question tipIcon"></i>
            </el-tooltip> -->

            <span class="viewInstance" @click="viewInstance"
              >点击查看示意图</span
            >
            <el-dialog v-model="studentCardDialog">
              <img
                style="width: 100%"
                src="../assets/img/studentCard.png"
                alt=""
              />
            </el-dialog>
          </div>
          <div
            class="myuploadPreview"
            v-show="formData.studentFile.length != 0"
          >
            <el-upload
              ref="coverFile"
              class="avatar-uploader myfile3"
              :show-file-list="false"
              :on-change="
                (file, fileList) => {
                  elUpload(file, fileList, 'studentFile');
                }
              "
              :auto-upload="false"
            >
              <img v-if="studentCardUrl" :src="studentCardUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item class="read-confirm">
          <el-checkbox v-model="formData.checked"></el-checkbox>
          <span class="protocol"
            >我已阅读<i @click="dialogVisible = true">《投稿须知》</i
            >，并同意所有条款</span
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="button-block"
            @click="formSubmitEvent"
            >确认上传</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="tougaoxuzhi">
      <el-dialog v-model="dialogVisible">
        <!-- <img style="width: 100%" src="../assets/img/tougaoxuzhi.jpg" alt="" /> -->
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
// import { uploadPic } from "../utils/upload2";
import { create, listAll, getOssSignature } from "../utils/apis/fileApi";
import { upload } from "../utils/uploadSign";
import { ElMessage } from "element-plus";
// import { error, log } from 'node:console';

export default {
  name: "upLoadFile",
  setup() {
    const coverUpload = ref(null);
    const uploadForm = ref(null);
    const contentDialog = ref(false);
    const dialogVisible = ref(false);
    const coverUrl = ref("");
    const contentUrl = ref("");
    const studentCardUrl = ref("");
    const studentCardDialog = ref(false);
    const showLoading = ref(false);
    const rules = reactive({
      name: [
        { required: true, message: "请输入作品名称", trigger: "blur" },
        {
          pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,10}$/,
          message: "仅限中英文，10个字以内",
          trigger: "blur",
        },
      ], //作品名
      category: [
        { required: true, message: "请选择作品类别", trigger: "change" },
      ], //作品类别
      description: {
        required: true,
        message: "请输入作品介绍",
        trigger: "blur",
      }, //作品介绍
      competitionUnit: [
        { required: true, message: "请选择作品类别", trigger: "change" },
      ], //参赛单元
      contents: [{ required: true, message: "请上传作品", trigger: "blur" }], //作品内容列表，阿里云存储的路径列表。
      adviser: [
        { required: true, message: "请填写指导老师姓名", trigger: "blur" },
        {
          pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,10}$/,
          message: "仅限中英文，10个字以内",
          trigger: "blur",
        },
      ],
      school: [
        { required: true, message: "请填写学校名称", trigger: "blur" },
        {
          pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,10}$/,
          message: "仅限中英文，10个字以内",
          trigger: "blur",
        },
      ],

      cover: [{ required: true, message: "请上传作品封面", trigger: "blur" }], //作品封面
    });
    const formData = reactive({
      name: "", //作品名
      category: "", //作品类别
      competitionUnit: "", //参赛单元
      contentFiles: [], //作品内容列表，阿里云存储的路径列表。
      coverFile: [], //作品封面
      recommenderId: "", //推荐单位
      school: "", //学校
      studentCard: [], //学生证明
      studentFile: [],
      cover: [],
      contents: [],
      checked: false,
      description: "",
      adviser: "",
    });
    const categoryList = reactive([
      {
        name: "平面类",
        value: 1,
      },
      {
        name: "动画类",
        value: 2,
      },
    ]);

    const unitList = reactive([
      {
        name: "主题单元",
        value: 1,
      },
      {
        name: "自由主题单元",
        value: 2,
      },
    ]);
    let list = ref([]);
    const mysign = reactive({
      data: null,
    });
    const recommendList = async () => {
      try {
        await listAll().then((res) => {
          list.value = res.data.data;
        });
      } catch (e) {
        console.log(e);
      }
    };
    recommendList();
    getSignature();

    const router = useRouter();
    //按钮点击实现上传
    function fileUpload(typeName) {
      if (typeName === "coverFile") {
        document.querySelector(".myfile1 .el-upload__input").click();
      } else if (typeName === "contentFiles") {
        if (formData.category == "") {
          ElMessage({
            message: "请选择作品类别",
            type: "error",
            customClass: "myElMessage",
          });

          return;
        }
        document.querySelector(".myfile2 .el-upload__input").click();
      } else {
        document.querySelector(".myfile3 .el-upload__input").click();
      }
    }
    // let recommendList;

    //查看学生证明图片
    function viewInstance() {
      studentCardDialog.value = true;
    }

    //移除文件
    function onRemove(file, filelist, listName) {
      formData[listName] = filelist;
    }

    //本地上传
    function upLoadCover(event, typeName, isElUpload) {
      let file = null;

      if (typeName === "coverFile") {
        beforeCoverUpload(event).then((res) => {
          // if (typeName === "coverFile") {
          if (res) {
            if (typeName === "coverFile" || typeName === "studentFile") {
              if (isElUpload) {
                file = [event.raw];
              } else {
                file = event.target.files;
              }
              upLoadAli(file, typeName);
            }
          } else {
            return;
          }
          // }
        });
      } else if (typeName === "contentFiles" && formData.category == 2) {
        beforeVideoUpload(event).then((res) => {
          if (res) {
            file = [event.raw];

            upLoadAli(file, typeName);
          }
        });
      } else {
        file = [event.raw];
        upLoadAli(file, typeName);
      }
    }

    function getSignature() {
      //获取签名
      getOssSignature().then((res) => {
        const sign = res.data.data;
        mysign.data = sign;
      });
    }

    function randomString(len) {
      len = len || 16;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678";
      let maxPos = chars.length;
      let str = "";
      for (let i = 0; i < len; i++) {
        str += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return str;
    }

    function getSuffix(filename) {
      let pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos !== -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    }

    //上传阿里 附带签名
    function upLoadAli(file, typeName) {
      const params = new FormData();
      params.append(
        "key",
        mysign.data.dir +
          `${dateFormat("yyyy-MM-dd")}/` +
          `${randomString()}${getSuffix(file[0].name)}`
      );
      params.append("OSSAccessKeyId", mysign.data.accessKeyId);
      params.append("policy", mysign.data.policy);
      params.append("signature", mysign.data.signature);
      params.append("callback", mysign.data.callback);
      params.append("success_action_status", "200"); // 上传成功返回的状态码，不设置则是204
      params.append("file", file[0]); // 一定在最后
      if (mysign.data.expiration < Date.now() + 60 * 1000) {
        getSignature();
      }
      //视频

      if (typeName === "contentFiles" && formData.category == 2) {
        showLoading.value = true;
      }
      upload(params, mysign.data.host)
        .then((res) => {
          if (res.data.code === 200) {
            let data = res.data.data;
            if (typeName === "coverFile") {
              if (formData.cover.length != 0) {
                formData.cover[0] = {
                  name: data.objectKey,
                  url: data.url,
                  status: "success",
                };
                formData[typeName][0] = file[0];
              } else {
                formData.cover.push({
                  name: data.objectKey,
                  url: data.url,
                  status: "success",
                }); //上传成功之后把值添加到imglist中

                formData[typeName].push(file[0]);
              }
              // console.log(data.url);
              coverUrl.value = data.url;
            } else if (typeName === "contentFiles") {
              if (formData.category != 2 || formData.contents.length === 0) {
                // res.map((item) => {
                formData.contents.push({
                  name: data.objectKey,
                  status: "success",
                  url: data.url,
                });
                // console.log(formData);
                formData[typeName].push(file[0]);
                // });
                if (formData.category == 2) {
                  showLoading.value = false;
                }
              } else {
                console.log(123);
                formData.contents[0] = {
                  name: data.objectKey,
                  status: "success",
                  url: data.url,
                };
                showLoading.value = false;
                formData[typeName][0] = file[0];
              }
            } else {
              if (formData.studentCard.length != 0) {
                formData.studentCard[0] = {
                  name: data.objectKey,
                  url: data.url,
                  status: "success",
                };
                formData[typeName][0] = file[0];
              } else {
                formData.studentCard.push({
                  name: data.objectKey,
                  url: data.url,
                  status: "success",
                }); //上传成功之后把值添加到imglist中

                formData[typeName].push(file[0]);
              }
              studentCardUrl.value = data.url;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    //eleupload自定义上传
    function elUpload(file, fileList, typeName) {
      upLoadCover(file, typeName, true);
    }

    //查看大图
    function handlePictureCardPreview(file) {
      contentDialog.value = true;
      contentUrl.value = file.url;
    }

    //移除文件
    function handleRemove(file) {
      let index = formData.contents.findIndex((item) => item.url === file.url);
      formData.contents.splice(index, 1);

      // formData.contentFiles
    }

    //视频上传检测
    function beforeVideoUpload(file) {
      console.log(file);
      return new Promise((reslove) => {
        let flag = true;

        if (file.type != "video/mp4") {
          ElMessage({
            message: `${file.name}类型不符合规范`,
            type: "error",
            customClass: "myElMessage",
          });
          flag = false;
        }
        videoPromise(file).then((res) => {
          var video = res;

          var duration = video.duration; // 得到时长
          let height = video.videoHeight;
          let width = video.videoWidth;
          console.log(duration);

          if (height != 1080 && width != 1920) {
            ElMessage({
              message: `${file.name}尺寸为${width}× ${height},不符合规范`,
              type: "error",
              customClass: "myElMessage",
            });

            flag = false;
          }
          reslove(flag);
        });
      });
    }

    function ElfileUpload(file) {
      return new Promise((reslove, reject) => {
        beforeVideoUpload(file).then((res) => {
          if (res) {
            reslove(res);
          } else {
            reject(res);
          }
        });
      });
    }

    //视频检测
    function videoPromise(file) {
      return new Promise((reslove) => {
        // var myVideo = [];
        window.URL = window.URL || window.webkitURL;
        // myVideo.push(file);
        var video = document.createElement("video");
        video.preload = "metadata";
        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
          console.log(video.videoWidth, video.videoHeight);
          reslove(video);
        };
        video.src = URL.createObjectURL(file);
      });
    }

    function beforeContentImageUpload(file) {
      return new Promise((reslove) => {
        let flag = true;

        if (!judgeType(file.name)) {
          ElMessage({
            message: `${file.name}类型不符合规范`,
            type: "error",
            customClass: "myElMessage",
          });

          flag = false;
        } else if (!judgeWorkSize(file.size)) {
          ElMessage({
            message: `${file.name}大小为 ${(file.size / 1024 / 1024).toFixed(
              2
            )}MB,不符合规范`,
            type: "error",
            customClass: "myElMessage",
          });
          flag = false;
        }
        reslove(flag);
      });
    }

    //上传文件检测
    function beforeCoverUpload(file) {
      return new Promise((reslove) => {
        let flag = true;

        if (!judgeType(file.name)) {
          ElMessage({
            message: `${file.name}类型不符合规范`,
            type: "error",
            customClass: "myElMessage",
          });

          flag = false;
        }
        if (!judgeSize(file.size)) {
          ElMessage({
            message: `${file.name}大小为 ${(
              file.raw.size /
              1024 /
              1024
            ).toFixed(2)}MB,不符合规范`,
            type: "error",
            customClass: "myElMessage",
          });

          flag = false;
        }
        reslove(flag);

        // myPromise(file.raw).then((img) => {
        //   myPromise2(img).then((img1) => {
        //     if (img1.width > 328 || img1.height > 246) {
        //       ElMessage.error(
        //         "上传图片分辨率建议328*246,宽度不可超过328px，高度不超过246px!"
        //       );
        //       flag = false;
        //     } else {
        //       flag = true;
        //     }
        //   });
        // });
      });
    }

    //类型判断
    function judgeType(filename) {
      var type = filename.toLowerCase().substr(filename.lastIndexOf("."));
      return type === ".jpg" || type === ".png" || type === ".gif";
    }

    //大小判断
    function judgeSize(size) {
      //小于5M
      return size <= 1024 * 1024 * 10;
    }

    function judgeWorkSize(size) {
      //小于3G
      return size <= 1024 * 1024 * 1024 * 3;
    }
    // function judgePixel(file) {
    //   // let reader = new FileReader();
    //   // let flag = false;
    //   // reader.readAsDataURL(file);
    //   // reader.onload = function (e) {
    //   //   let img = new Image();
    //   //   img.src = e.target.result;
    //   //   img.onload = function () {
    //   //     if (img.width > 328 || img.height > 246) {
    //   //       flag = true;
    //   //     }
    //   //   };
    //   // };
    //   // return flag;
    // }

    // function myPromise(file) {
    //   return new Promise((reslove) => {
    //     let reader = new FileReader();

    //     reader.readAsDataURL(file);
    //     reader.onload = function (e) {
    //       let img = new Image();
    //       img.src = e.target.result;
    //       reslove(img);
    //     };
    //   });
    // }
    // function myPromise2(img) {
    //   return new Promise((reslove) => {
    //     img.onload = function () {
    //       console.log(img.width);
    //       console.log(img.height);

    //       reslove(img);
    //     };
    //   });
    // }

    //提交上传
    function formSubmitEvent() {
      if (!formData.checked) {
        ElMessage({
          message: `请同意 《投稿须知》`,
          type: "error",
          customClass: "myElMessage",
        });

        return;
      }
      if (formData.cover.length === 0) {
        ElMessage({
          message: `封面没有上传`,
          type: "error",
          customClass: "myElMessage",
        });

        return;
      }
      if (formData.contents.length === 0) {
        ElMessage({
          message: `作品没有上传`,
          type: "error",
          customClass: "myElMessage",
        });

        return;
      }
      if (formData.competitionUnit == 2 && formData.studentCard.length === 0) {
        ElMessage({
          message: `学生证明没有上传`,
          type: "error",
          customClass: "myElMessage",
        });
        return;
      }
      uploadForm.value.validate(async (vaild) => {
        if (vaild) {
          let params = {
            name: formData.name,
            category: formData.category,
            competitionUnit: formData.competitionUnit,
            contents: (() => {
              return formData.contents.map((item) => item.name);
            })(),
            cover: formData.cover[0].name,
            recommenderId: formData.recommenderId,
            description: formData.description,
            school: formData.competitionUnit == 2 ? formData.school : "",
            studentCard:
              formData.competitionUnit == 2 ? formData.studentCard[0].name : "",
            adviser: formData.competitionUnit == 2 ? formData.adviser : "",
          };

          saveData(params);
        }
      });
    }

    function cateChange() {
      formData.contents = [];
      formData.contentFiles = [];
    }

    function saveData(params) {
      create(params)
        .then((res) => {
          if (res.data.code == 200) {
            ElMessage({
              message: res.data.message,
              type: "success",
              customClass: "myElMessage",
            });

            router.push({ path: "/myWorks" });
          } else {
            ElMessage({
              message: res.data.message,
              type: "error",
              customClass: "myElMessage",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    function beforeAvatarUpload(file) {
      // if (!judgeType(file.name)) {
      //   ElMessage.error(`${file.name}类型不符合规范`);
      //   return false;
      // }
      // if (!judgeWorkSize(file.size)) {
      //   ElMessage.error(
      //     `${file.raw.name}大小为 ${(file.size / 1024 / 1024).toFixed(
      //       2
      //     )}MB,不符合规范`
      //   );
      //   return false;
      // }
      // return true;
      return new Promise((reslove, reject) => {
        beforeContentImageUpload(file).then((res) => {
          if (res) {
            reslove(res);
          } else {
            reject(res);
          }
        });
      });
    }

    function handleUploadFn(option) {
      // console.log(option);
      let file = [option.file];

      upLoadAli(file, "contentFiles");
    }

    function handleVideoFn(option) {
      let file = [option.file];
      upLoadAli(file, "contentFiles");
    }

    function dateFormat(fmt) {
      let getDate = new Date();
      let o = {
        "M+": getDate.getMonth() + 1,
        "d+": getDate.getDate(),
        "h+": getDate.getHours(),
        "m+": getDate.getMinutes(),
        "s+": getDate.getSeconds(),
        "q+": Math.floor((getDate.getMonth() + 3) / 3),
        S: getDate.getMilliseconds(),
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      if (fmt.includes("NaN")) {
        return "请刷新页面后重试";
      }
      return fmt;
    }

    return {
      rules,
      formData,
      upLoadCover,
      categoryList,
      unitList,
      coverUpload,
      contentDialog,
      coverUrl,
      contentUrl,
      onRemove,
      fileUpload,
      elUpload,
      cateChange,
      handlePictureCardPreview,
      handleRemove,
      studentCardDialog,
      studentCardUrl,
      viewInstance,
      formSubmitEvent,
      uploadForm,
      saveData,
      beforeCoverUpload,
      // uploadAli,
      recommendList,
      list,
      beforeAvatarUpload,
      handleUploadFn,
      handleVideoFn,
      ElfileUpload,
      showLoading,
      dialogVisible,
    };
  },
};
</script>

<style lang="less" scoped>
#upLoadFile {
  padding-top: 70px;
  width: 1200px;
  margin: 0 auto;
  .title {
    font-size: 36px;
    font-weight: bold;
    color: #303133;
    text-align: center;
    margin-bottom: 55px;
  }
  .form {
    width: 550px;
    margin: 0 auto;
    padding-bottom: 200px;
    .el-form-item__label {
      font-size: 14px;
      color: #303133;
    }
  }
  .tip {
    color: #ff0000;
    margin-left: 20px;
  }
}
.button-inline {
  width: 150px;
  height: 40px;
}
.upload-content {
  ::v-deep img {
    object-fit: cover;
  }
}

.upload-tip {
  margin: 8px 0;
  line-height: 14px;
  font-size: 14px;
  color: #c0c4cc;
  height: 14px;
}
.works-type {
  width: 180px;
}
.input-item {
  width: 400px;
}
::v-deep .el-input--suffix .el-input__inner::placeholder {
  color: #c0c4cc;
}
::v-deep .el-form-item {
  margin-bottom: 20px;
}
::v-deep .el-upload-list--picture .el-upload-list__item-status-label {
  background: #303133;
}
::v-deep .el-upload-list--picture .el-upload-list__item {
  height: 95px;
  padding-top: 12.5px;
}
.recommend-wrap {
  ::v-deep .el-form-item__label {
    text-align: left;
    line-height: normal;
  }
}
// /deep/ .el-list-enter-active,
// /deep/ .el-list-leave-active {
//   transition: none;
// }
.protocol {
  vertical-align: -1px;
  color: #909399;
  margin-left: 10px;
  i {
    font-style: normal;
    cursor: pointer;
    transition: 0.2s;
  }
  i:hover {
    color: #003588;
  }
}

.button-block {
  height: 40px;
  width: 400px;
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before {
  display: none;
}
// .read-confirm ::v-deep .el-form-item__content {
//   line-height: normal;
// }
.myfile {
  display: none;
}
::v-deep .el-textarea__inner {
  height: 120px;
}
.myuploadPreview .avatar-uploader {
  line-height: 0;
}
.myuploadPreview /deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 95px;
  height: 95px;
  line-height: 95px;
  text-align: center;
}
.avatar {
  width: 95px;
  height: 95px;
  display: block;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 95px;
  height: 95px;
}
::v-deep .el-upload--picture-card {
  width: 95px;
  height: 95px;
  line-height: 95px;
}
.checkInstance {
  display: inline-block;
  margin-left: 15px;
  font-size: 14px;
  color: #909399;
}
.tipIcon {
  font-size: 25px;
  color: dcdfe6;
  vertical-align: middle;
  margin-right: 10px;
  cursor: pointer;
}
.viewInstance {
  vertical-align: middle;
  cursor: pointer;
}
.viewInstance:hover {
  color: #003588;
}
.mytip {
  line-height: 24px;
}
::v-deep {
  .el-upload-list__item {
    transition: none !important;
  }
}
.title::after {
  display: block;
  content: "";
}
.tougaoxuzhi/deep/ .el-dialog {
  // height:5px;
  height: 744px;
  width: 790px !important;
  background-image: url("../assets/img/tougaoxuzhi.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  // background-position:center;
}
</style>
